import { useTokenStore } from '@/store';
import { Capacitor } from '@capacitor/core';

export const heartBeatOpts = {
  ping: 'ping', // ping
  pong: 'pong',
  interval: 15000, // 心跳间隔时间
  waittime: 10000, // 心跳等待时间
};

export const socketOpts = {
  // url: 'ws://localhost:3000',
  // reconnect: true,
  // reconnectAttempts: 5,
  // reconnectDelay: 3000,
  // autoConnect: true,
  // transports: ['websocket'],
  // pingTimeout: 10000,
  // pingInterval: 5000,
  // forceNew: true,
  // secure: true,
  // rejectUnauthorized: false,
  timeout: 10000, // 消息超时时间, 超时算失败
};

// const host =
//   import.meta.env.MODE == 'development'
//     ? '192.168.17.87:18087'
//     : `${location.host}`;
export const wsUrl = async () => {
  const tokenStore = useTokenStore();
  const platform = Capacitor.getPlatform(); // web、ios 或 android
  const baseWsUrl =
    platform === 'web'
      ? import.meta.env.VITE_WS_URL!
      : import.meta.env.VITE_APP_WS_URL!;
  return new Promise((resolve) => {
    setTimeout(() => {
      const accessToken = tokenStore.token.accessToken;
      const socketUrl = baseWsUrl + accessToken;
      console.log('socketUrl=============', socketUrl);
      resolve(socketUrl);
    }, 100);
  });
};
